// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"127":"search-modal","764":"markdown"}[chunkId] || chunkId) + "-" + {"69":"62f295dd0909ec31c10d","127":"22ce14089adc6a793d2a","261":"62c54fe20e34c9b0ae65","764":"96143b5649d45d079529"}[chunkId] + ".chunk.js";
};